/**
 * <nwf-countdown data-target="{{ unix timestamp }}">
 *
 * Ticks down "X hours Y minutes" until the given target timestamp (order
 * cutoff time), rendered server-side for the initial paint, then updated
 * client-side every 30 seconds. Once the target passes, the element removes
 * itself (the surrounding delivery-date range stays accurate until the next
 * page load, matching the theme's other date/inventory blocks).
 */
class NwfCountdown extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.valueEl = this.querySelector('[data-nwf-countdown-value]');
        this.targetMs = parseInt(this.dataset.target, 10) * 1000;
        this.hoursUnit = this.dataset.hoursUnit || '';
        this.minutesUnit = this.dataset.minutesUnit || '';

        this.update();
        this.interval = setInterval(this.update.bind(this), 30000);
    }

    disconnectedCallback() {
        clearInterval(this.interval);
    }

    update() {
        const remainingMs = this.targetMs - Date.now();

        if (remainingMs <= 0) {
            clearInterval(this.interval);
            this.remove();
            return;
        }

        const hours = Math.floor(remainingMs / 3600000);
        const minutes = Math.floor((remainingMs % 3600000) / 60000);

        if (!this.valueEl) return;

        this.valueEl.textContent =
            hours > 0 ? `${hours} ${this.hoursUnit} ${minutes} ${this.minutesUnit}` : `${minutes} ${this.minutesUnit}`;
    }
}

customElements.define('nwf-countdown', NwfCountdown);
